import { useCallback, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useLogs = () => {
  const { baseUrl, basicAuth, userID } = useContext(GlobalContext);

  const postRequest = async (endpoint, body) => {
    const res = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        Authorization: basicAuth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    return res.json();
  };

  const getCampaignLogs = useCallback(async (campaignId, status) => {
    return await postRequest(
      "/Whatsapp/v1.0/getWhatsappLogs",
      { userid: userID, campaignId, status }
    );
  }, [userID]);

  const getAllMessageLogs = useCallback(async (payload) => {
    return await postRequest(
      "/Whatsapp/getAllWhatsappLogs",
      payload
    );
  }, []);

  return { getCampaignLogs, getAllMessageLogs };
};

export default useLogs;